import { SR_API_ACTION_ACCOUNT_MANAGER_GET_LIST_WITH_PARTNERS } from 'api/actionTypes';

export default async function getListWithPartners({ state, apiClient }) {
  if (state.get(['accountManagers', 'listWithPartners'])) {
    return;
  }
  await apiClient.postWithState({
    action: SR_API_ACTION_ACCOUNT_MANAGER_GET_LIST_WITH_PARTNERS,
    state: state,
    onSuccess(accountManagers) {
      state.set(['accountManagers', 'listWithPartners'], accountManagers);
    },
  });
}
